import LegacyExperience from './Enrollment.legacy';
import { versioned } from '../../versioning/RenewalExperience';
import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle, useRef } from 'react';
import { Row, Col, Card, OverlayTrigger, Tooltip, Form } from 'react-bootstrap';
import axios from 'axios';
import debounce from 'lodash/debounce';
import Select from 'react-select';
import config from '../../config';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";


const options = [
    { value: "Manual", label: "We will manually enter our enrollment directly into the platform" },
    { value: "Clarity Comprehensive API", label: "We will connect to our benefits/payroll provider with Clarity's Comprehensive API" },
    { value: "ENav", label: "We use Employee Navigator as set up by our broker and will send demographic and enrollment information through the Employee Navigator Marketplace" },
    { value: "Ease", label: "We use EASE as set up by our broker and will send demographic and enrollment information through the EASE Marketplace" }
]



const Enrollment = forwardRef(({ caseId, renewalCase, isDisableForUsers, onError = () => { } }, ref) => {

    const [enrollment, setEnrollment] = useState(null);
    
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [validationErrors, setValidationErrors] = useState({});
    const handleToggleIsChange = (checked, property) => {
       
        const value = checked;
        setEnrollment(prevInfo => {
            const updatedInfo = { ...prevInfo, [property]: value };
            debouncedUpdate({ [property]: value });
            return updatedInfo;
        });
    };

    useEffect(() => {
        const fetchGeneralInfo = async () => {
            try {
                const response = await axios.get(`${config.API_URL}/EBEnrollments/ByCaseId/${caseId}`);
                const fetchedEnrollment = response.data || null;

                
                

                setEnrollment(fetchedEnrollment);

            } catch (error) {
                setError('Error fetching plans.');
            } finally {
                setLoading(false);
            }
        };
        fetchGeneralInfo();
        
    }, [caseId]);

    const debouncedUpdate = useCallback(
        debounce(async (updatedFields) => {

            try {
                const patchDocument = Object.keys(updatedFields).map(key => ({
                    path: `/${key}`,
                    value: updatedFields[key]
                }));
                await axios.patch(`${config.API_URL}/EBEnrollments/${enrollment?.id}`, patchDocument);
            } catch (error) {
                console.error('Error updating plan:', error);
                onError(error);
            }

        }, 500),
        [onError, validationErrors, caseId]
    );


    const validateField = (name, value) => {
        let errors = { ...validationErrors };

        switch (name) {
            case 'transmissionType':
                if (enrollment?.isChanged && !value) {
                    errors[name] = 'Transmission type is required';
                } else {
                    delete errors[name];
                }
                break;

            

            case 'transmissionDate':
                if (enrollment?.transmissionDate && !value) {
                    errors[name] = 'Transmission date is required';
                } else {
                    delete errors[name];
                }
                break;

            default:
                break;
        }

        setValidationErrors(errors);
    };


    const validateAll = () => {
        let errors = { ...validationErrors };



        if (enrollment?.isChanged && !enrollment?.transmissionType) {
            errors['transmissionType'] = 'Transmission type is required';
        } else {
            delete errors['transmissionType'];
        }


        

        if (!enrollment?.transmissionDate) {
            errors['transmissionDate'] = 'Transmission date is required';
        } else {
            delete errors['transmissionDate'];
        }





        setValidationErrors(errors);

        // Return true if no errors, false if there are errors
        return Object.keys(errors).length === 0;
    };

    useImperativeHandle(ref, () => ({
        validateAll,
    }));

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        validateField(name, value);
        setEnrollment(prevInfo => {
            const updatedInfo = { ...prevInfo, [name]: value };
            debouncedUpdate({ [name]: value });
            return updatedInfo;
        });
    };

    const handleSelectChange = (selectedOption, { name }) => {
        const value = selectedOption ? selectedOption.value : '';
        validateField(name, value);
        setEnrollment(prevInfo => {
            const updatedInfo = { ...prevInfo, [name]: value };
            debouncedUpdate({ [name]: value });
            return updatedInfo;
        });
    };

    const handleDateChange = (fieldName, date) => {
        if (date) {
            // Normalize the date to prevent timezone issues
            const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    
            // Format the date as MM/dd/yyyy
            const formattedDate = localDate.toLocaleDateString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            });
    
            // Perform field validation
            validateField(fieldName, formattedDate);
    
            // Update the state and trigger debounced update
            setEnrollment((prevInfo) => {
                const updatedInfo = { ...prevInfo, [fieldName]: formattedDate };
                debouncedUpdate({ [fieldName]: formattedDate });
                return updatedInfo;
            });
        } else {
            // Handle the case when the date is cleared (null)
            setEnrollment((prevInfo) => {
                const updatedInfo = { ...prevInfo, [fieldName]: '' }; // Clear the field
                debouncedUpdate({ [fieldName]: '' }); // Update the backend with an empty value
                return updatedInfo;
            });
        }
    };
    

    const customStyles = (hasError) => ({
        control: (provided) => ({
            ...provided,
            borderColor: hasError ? '#dc3545' : provided.borderColor,
            '&:hover': {
                borderColor: hasError ? '#dc3545' : provided.borderColor,
            },
            boxShadow: hasError ? '0 0 10px rgba(220, 53, 69, 0.5)' : provided.boxShadow,
        }),
    });

    const handleToggleChange = (e, property) => {
        const { checked } = e.target;
        const value = checked;
        setEnrollment(prevInfo => {
            const updatedInfo = { ...prevInfo, [property]: value };
            debouncedUpdate({ [property]: value });
            return updatedInfo;
        });
    };

    //const isDisabled = renewalCase?.ebSubmissionStatus === 'Submitted' || isDisableForUsers;
    const isDisabled =  isDisableForUsers;
    if (renewalCase?.ebEnrollmentFileSource === 'Not Indicated' && enrollment?.isChanged !== true) {
                    
        handleToggleIsChange(true, 'isChanged');
    }
    return (
        <Col lg={12} className='mb-3'>
            <Card>
                <Card.Body>
                    <Card.Title>Enrollment </Card.Title>
                    <Row className="mb-3">
                        <Col lg={12} >
                            <span >
                                Our records indicate your current data transmission method is <strong>{renewalCase?.ebEnrollmentFileSource}</strong>
                            </span>
                        </Col>
                    </Row>
                    <Row className="mb-3">

                        <Col lg={4}>
                            <div className="d-flex align-items-center">
                                <Form.Label>
                                    If this has changed, please update here
                                </Form.Label>
                                <div className="form-check form-switch form-toggle">
                                    <input
                                        type="checkbox"
                                        className="form-check-input-toggel form-check-input toggle-input-switch is-change-toggle"
                                        role="switch"
                                        checked={renewalCase?.ebEnrollmentFileSource ==="Not Indicated" || enrollment?.isChanged}
                                        onChange={(e) => handleToggleChange(e, 'isChanged')}
                                        disabled={isDisabled || renewalCase?.ebEnrollmentFileSource ==="Not Indicated"}
                                    />
                                </div>
                            </div>
                        </Col>

                        {enrollment?.isChanged && (
                            <Col lg={6}>
                                
                                    <Select
                                        name="transmissionType"
                                        placeholder="Please select"
                                        options={options}
                                        value={options.find(option => option.value === enrollment?.transmissionType)}
                                        onChange={handleSelectChange}
                                        styles={customStyles(validationErrors && validationErrors.transmissionType)}
                                        isDisabled={isDisabled}
                                    />
                                
                                {validationErrors && validationErrors.transmissionType && (
                                    <div className="invalid-feedback d-block">
                                        {validationErrors.transmissionType}
                                    </div>
                                )}
                            </Col>
                        )}
                    </Row>

                    {(enrollment?.isChanged && enrollment?.transmissionType?.includes('Clarity Comprehensive API')) && (
                            <Row className="mb-3">
                                
                                <em>API Terms &amp; Conditions - Electronic Acceptance: By selecting “Clarity Comprehensive API” above and 
                                    completing this renewal, you confirm that you (the “Client") have read and accept the 
                                    <a href='https://kits.claritybenefitsolutions.com/api-integration-terms-and-conditions/' target='_blank'>
                                    API Integration Terms and Conditions
                                    </a> 
                                    and are duly authorized to bind the Client identified above. Your electronic acceptance and related electronic 
                                    records have the same legal effect as a signed writing under applicable law. The Client’s continued use of the 
                                    API Integration services also constitute acceptance of those terms.</em>
                                    
                                    </Row>
                        )}
                    
                    <Row className='mb-3'>
                        <Col lg={4}>
                        <Form.Label>
                        Estimated Date of Enrollment Transmission
                                </Form.Label>
                        </Col>
                        <Col lg={6}>
                            <div className="d-flex">
                                <span className="input-group-text">
                                    <i className="far fa-calendar-alt"></i>
                                </span>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="payDate-tooltip">Estimated Date of Enrollment Transmission</Tooltip>}
                                >
                                    <div>

                                        <DatePicker
                                            className={`form-control ${validationErrors && validationErrors.transmissionDate ? 'is-invalid' : ''}`}
                                            selected={enrollment?.transmissionDate || ''}
                                            onChange={(date) => handleDateChange('transmissionDate', date)}
                                            placeholderText="Estimated Date of Enrollment Transmission"
                                            disabled={isDisabled}
                                            minDate={new Date()}
                                        />
                                    </div>
                                </OverlayTrigger>
                            </div>
                            {validationErrors && validationErrors.transmissionDate && (
                                <div className="invalid-feedback d-block">
                                    {validationErrors.transmissionDate}
                                </div>
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </Col>);
});

export default versioned(Enrollment, LegacyExperience);
